import { constants } from "../constants/redux-constants";

const initialState = {
  tasks: [],
  showTaskInProgressPopup: false
};

export default function BackgroundtaskReducer(state = initialState, action) {
  switch (action.type) {
    case constants.BACKGROUND_TASKS.ADD_TASK: {
      const newTask = action.payload;
      if (state.tasks.some((t) => t.id === newTask.id)) {
        return state;
      }
      return {
        ...state,
        tasks: [{ ...newTask, isRead: false }, ...state.tasks],
      };
    }

    case constants.BACKGROUND_TASKS.UPDATE_TASK:
      return {
        ...state,
        tasks: state.tasks.map((task) =>
          task.id === action.payload.id
            ? { ...task, ...action.payload.updates }
            : task
        ),
      };

    case constants.BACKGROUND_TASKS.DELETE_TASK:
      return {
        ...state,
        tasks: state.tasks.filter((task) => task.id !== action.payload),
      };

    case constants.BACKGROUND_TASKS.CLEAR_TASKS:
      return {
        ...state,
        tasks: state.tasks.filter(task => task.status === "IN_PROGRESS")
      };

    case constants.BACKGROUND_TASKS.MARK_AS_READ:
      return {
        ...state,
        tasks: state.tasks.map((task) =>
          task.id === action.payload
            ? { ...task, isRead: true }
            : task
        ),
      };

    case constants.BACKGROUND_TASKS.MARK_FAILED_AS_READ:
      return {
        ...state,
        tasks: state.tasks.map((task) =>
          task.status === "FAILED" ? { ...task, isRead: true } : task
        ),
      };

    case constants.BACKGROUND_TASKS.REMOVE_ACTIVE_TASKS:
      return {
        ...state,
        tasks: state.tasks.filter(
          (task) => !['IN_PROGRESS', 'QUEUED'].includes(task.status)
        ),
      };

    case constants.BACKGROUND_TASKS.SHOW_TASK_INPROGRESS_POPUP:
      return {
        ...state,
        showTaskInProgressPopup: action.payload,
      };
    default:
      return state;
  }
}